module.exports = __webpack_public_path__ + "img/r4.36d8b6ed.png";